import { CheckCircle2, ArrowRight } from "lucide-react";
import policyStackImg from "@/assets/policy-stack-dashboard.png";

const values = [
  "One organized household view",
  "Policy information in one place",
  "Loan and repayment tracking",
  "Greater visibility into your Family Banking System",
  "Better preparation for coaching reviews",
  "Ongoing education and engagement",
];

export const PolicyStackSection = () => (
  <section data-testid="policy-stack-section" className="section-lr relative overflow-hidden bg-ivory">
    {/* Deferred background texture slot: policy-stack-planning-texture.jpg, 2200×1400px, low-contrast planning/organization detail. */}
    <div className="pointer-events-none absolute inset-0 opacity-60 bg-[radial-gradient(circle_at_82%_20%,rgba(197,161,90,0.18),transparent_28%),linear-gradient(135deg,rgba(255,255,255,0.65),rgba(239,232,217,0.12))]" />
    <div className="container-lr relative grid gap-12 lg:grid-cols-[1fr_0.9fr] lg:items-center">
      <div>
        <div className="flex items-center gap-4"><span className="gold-rule" /><p className="eyebrow">Where Education Becomes Implementation</p></div>
        <h2 className="section-heading mt-6 text-legacy">Where your financial system <span className="accent-word">comes to life.</span></h2>
        <p className="mt-6 text-lg leading-relaxed text-legacy/85">We use Policy Stack to help every client organize, track, and improve their Family Banking System.</p>
        <p className="mt-4 text-base leading-relaxed text-slate">A financial strategy should not disappear into a folder after implementation. Policy Stack gives each household a central place to organize policies, monitor important values, track loans and repayments, and understand how the system develops over time.</p>
        <a href="https://policystack.co/?ref=LEGACYLIFE&via=legacylife-general" target="_blank" rel="noopener noreferrer" aria-label="Explore Policy Stack (opens the Policy Stack website in a new tab)" data-testid="policy-stack-cta" className="btn-base btn-outline-dark mt-8">Explore Policy Stack <ArrowRight size={17} /></a>
      </div>
      <div className="lr-card overflow-hidden bg-white p-4 md:p-5">
        <div className="overflow-hidden rounded-2xl border border-gold/30 shadow-[0_24px_50px_-30px_rgba(17,17,17,0.45)]">
          <img src={policyStackImg} alt="Policy Stack Infinite Banking Concept Dashboard" loading="lazy" className="block h-auto w-full object-contain" />
        </div>
        <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-1">
          {values.map((value) => <li key={value} className="flex items-start gap-3 text-sm leading-relaxed text-slate"><CheckCircle2 size={18} className="mt-0.5 shrink-0 text-bronze" />{value}</li>)}
        </ul>
      </div>
    </div>
  </section>
);
